import React from "react";
import { Link, useLocation } from "react-router-dom";
import DeleteAccIcon from "../assets/icons/DeleteAccIcon";
import FeedbackIcon from "../assets/icons/FeedbackIcon";
import WalletIcon from "../assets/icons/WalletIcon";
import OfferIcon from "../assets/icons/OfferIcon";
import OrderIcon from "../assets/icons/OrderIcon";
import ProfileIcon from "../assets/icons/ProfileIcon";
import Refer from "../assets/icons/Refer";
import { useTranslation } from "react-i18next";

const Sidebar = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const menuItems = [
    {
      name: t('profile'),
      path: "/account/profile",
      icon: <ProfileIcon />,
    },
    {
      name: t('order_history'),
      path: "/account/orders",
      icon: <OrderIcon />,
    },
    {
       name: t('wallet'),
      // name:
      path: "/account/wallet",
      icon: <WalletIcon />,
    },
    // {
    //   name: "Give Feedback",
    //   path: "/account/feedback",
    //   icon: <FeedbackIcon />,
    // },
    // {
    //   name: "Delete Account",
    //   path: "#",
    //   icon: <DeleteAccIcon />,
    // },
  ];

  return (
    <aside className="sidebar_main bg-custom">
      <p className="sidebar_p">{t('account_setting')}</p>
      <nav>
        <ul className="sidebar_ul">
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className={`${location.pathname === item.path && "active"}`}
              >
                {item.icon}
                <span>{item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
